const giftConstraints = function () {

  const constraints = {
    dwfrm_gift_firstName: {
      presence: {
        allowEmpty: false,
      },
    },

    dwfrm_gift_lastName: {
      presence: {
        allowEmpty: false,
      },
    },

    dwfrm_gift_giftMessage: {
      presence: {
        allowEmpty: false,
      },
    },

    dwfrm_gift_email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    }
  }

  return constraints;
};

export default giftConstraints;
